import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ kicker, title, dark = false, testId }) => (
  <Reveal className="max-w-3xl mb-14 md:mb-20">
    <p data-testid={testId ? `${testId}-kicker` : undefined} className={`font-mono2 text-[10px] md:text-[11px] uppercase tracking-[0.3em] mb-5 ${dark ? "text-gold" : "text-terra"}`}>
      {kicker}
    </p>
    <h2 data-testid={testId ? `${testId}-title` : undefined} className={`font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight ${dark ? "text-paper" : "text-ink"}`}>
      {title}
    </h2>
  </Reveal>
);
